import { useEffect, useState } from "react";
import {
  fetchServiceTimelyComparisonCharts,
  ServiceTimelyComparisonPeriod,
} from "../services/serviceTimelyComparisonDashboardApi";
import { SalesTimelyComparisonChartsResponse } from "../services/salesTimelyComparisonDashboardApi";

interface ServiceTimelyComparisonChartsState {
  data: SalesTimelyComparisonChartsResponse | null;
  isLoading: boolean;
  error: string | null;
}

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  return "Failed to load Service trend charts.";
};

export const useServiceTimelyComparisonCharts = (
  period: ServiceTimelyComparisonPeriod,
  enabled: boolean,
  refreshKey = 0,
): ServiceTimelyComparisonChartsState => {
  const [state, setState] = useState<ServiceTimelyComparisonChartsState>({
    data: null,
    isLoading: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;

    let isCurrent = true;

    setState((current) => ({
      ...current,
      isLoading: true,
      error: null,
    }));

    fetchServiceTimelyComparisonCharts(period)
      .then((data) => {
        if (!isCurrent) return;
        setState({ data, isLoading: false, error: null });
      })
      .catch((error) => {
        if (!isCurrent) return;
        setState((current) => ({
          ...current,
          isLoading: false,
          error: getErrorMessage(error),
        }));
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled, period, refreshKey]);

  return state;
};
